// extracted by mini-css-extract-plugin
export default {"container":"_24MQX___Toggle-module__container","input":"aCHqV___Toggle-module__input","label":"LdisQ___Toggle-module__label","large":"_3L033___Toggle-module__large"};